import b from 'b_';
import { Copy, TrashClearKit, Quiz, WarningFilled } from 'education-icons';
import { Popup, SimpleCallback, Text } from 'platform-components';
import { POPUP_DIRECTIONS, POPUP_THEMES } from 'platform-components/constants';
import React, { useRef } from 'react';
import { accessibleClick } from '@edu-frontend/modules/src/shared/lib/a11y';

import './quiz-editor__reel-item.scss';

interface Props {
    index: number;
    isActive: boolean;
    onClick: SimpleCallback;
    onCopy: (event: React.MouseEvent<HTMLElement>) => void;
    onDelete: (event: React.MouseEvent<HTMLElement>) => void;
    shouldShowWarning: boolean;
    shouldShowDeleteButton: boolean;
    shouldShowControls: boolean;
}

export const QuizEditorReelItem = (props: Props) => {
    const {
        index,
        isActive,
        onClick,
        onCopy,
        onDelete,
        shouldShowControls,
        shouldShowDeleteButton,
        shouldShowWarning,
    } = props;

    const tooltipRef = useRef<Popup>(null);

    const showTooltip = () => {
        tooltipRef?.current?.show();
    };

    const hideTooltip = () => {
        tooltipRef?.current?.hide();
    };

    return (
        <div className={b('quiz-editor__reel-item', { active: isActive })} {...accessibleClick(onClick)}>
            <Quiz className="reel-item__quiz-logo" />
            {shouldShowWarning && (
                <>
                    <div
                        className="reel-item__warning-icon-wrapper"
                        onMouseEnter={showTooltip}
                        onMouseLeave={hideTooltip}
                    >
                        <WarningFilled className="reel-item__warning-icon" />
                    </div>
                    <Popup
                        direction={POPUP_DIRECTIONS.RIGHT}
                        hasArrow
                        offsetLeft={32}
                        offsetTop={23}
                        ref={tooltipRef}
                        theme={POPUP_THEMES.DARK_ROUNDED}
                    >
                        <Text className="reel-item__popup-text" id="teacherLab.quizEditor.reelItem.warningMessage" />
                    </Popup>
                </>
            )}

            {shouldShowControls && (
                <div className="reel-item__control-container">
                    {shouldShowDeleteButton && (
                        <div className="reel-item__control" {...accessibleClick(onDelete)}>
                            <TrashClearKit className="reel-item__control-icon" />
                        </div>
                    )}
                    <div className="reel-item__control" {...accessibleClick(onCopy)}>
                        <Copy className="reel-item__control-icon" />
                    </div>
                </div>
            )}

            <div className="reel-item__index">{index + 1}</div>
        </div>
    );
};
